<template>
	<transition name="slide-fade">
		<span>
		<!-- <main class="col-xs-12 npd">
			<img v-bind:src="theme_url+'/html/assets/img/holder.jpg'" alt="" width="100%">
		</main> -->
		<div class="col-xs-12">
			<div class="container" v-if="loaded === 'true'">
				<div class="row">
					<h2>LOCUTORES</h2>

					<div class="col-xs-6 col-md-3 locutor-item" v-for="locutor in locutores">


						<figure v-if="locutor.better_featured_image !== null">
							<img v-bind:src="locutor.better_featured_image.media_details.sizes['530x626'].source_url" alt="" class="shadow">
						</figure>
						<figure v-else>
							<img v-bind:src="theme_url+'/html/assets/img/locutor.jpg'" alt="" class="shadow">
						</figure>
						<h4 v-html="locutor.title.rendered"></h4>
						<ul>
							<li>
								<router-link :to="{ name: 'locutor', params: { locutor: locutor.slug }}">
									Ver Biografía
								</router-link>
							</li>

							<li v-if="typeof locutor.acf.programas == 'object'">
								<router-link :to="{ name: 'programa', params: { elprograma: locutor.acf.programas[0].post_name }}">
									Ver Programa
								</router-link>
							</li>
						</ul>
					</div>

				</div>
			</div>
		</div>
	</span>
	</transition>

</template>


<script>
export default {
	mounted: function() {
		const vm = this;
		vm.getLocutores();
	},
	data() {
		return {
			theme_url:rtwp.theme_url,
			locutores: {},
			loaded: 'false',
		};
	},
	methods: {
		getLocutores: function( ) {
			const vm = this;
			vm.loaded = 'false';
			vm.$http.get( 'wp/v2/locutores',{
				params: { per_page: 99 }
			})
			.then( ( res ) => {
				vm.locutores = res.data;
				// window._locutores=vm.locutores;
				vm.loaded = 'true';
				vm.$nextTick(function(){
					init_attach();
				});
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		}

	}
};
</script>



// WEBPACK FOOTER //
// locutores.vue?b39d968a